<nav class="navbar navbar-expand-sm navbar-dark " style="background-color: #09c;">
    <a class="navbar-brand" routerLink="movies">Movies</a>
    <a class="navbar-brand" routerLink="series">Series</a>
    
    <div class="ml-md-auto">
        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
           
            
            <li class="nav-item">
                <button *ngIf = "loggedin() " (click)="logout() " class="btn btn-danger">Logout</button>
            </li>
            <li class="nav-item">
                <button routerLink="/signin" *ngIf = "!loggedin() then  "   class="btn btn-danger marginRight">Login</button>
                <button routerLink="/signup" *ngIf = "!loggedin() "   class="btn btn-danger">Register</button>
            </li>
            

            
           
        </ul>
      
    </div>
</nav>